import { Seo } from "@/components/base"
import Layout from "@/components/layout"
import { Liquidations } from "@/components/liquidations"
import useTrans from "@/hooks/useTrans"
import { sendEventLog } from "@/utils/tracking-events"
import { useEffect } from "react"
import { dehydrate, QueryClient, useQuery } from "react-query"

import { NextAPIRequests } from "@/apis/nextAPIRequests"
import { poolsAtom } from "@/atoms/pools"
import { networkAtom } from "@/atoms/settings"
import useSetupOnChain from "@/hooks/useSetupOnChain"
import { useAtomValue, useSetAtom } from "jotai"
import { GetStaticProps } from "next"
import useMarketSelection from "@/hooks/useMarketSelection"

const LiquidationsPage = () => {
  const trans = useTrans()
  // for switching network
  const network = useAtomValue(networkAtom)
  const { data: poolValues } = useQuery(
    ["fetchPools", network],
    () =>
      NextAPIRequests.fetchPools({
        refresh: true,
        network,
      }),
    {
      staleTime: 10000,
      refetchOnWindowFocus: false,
    },
  )
  const setPools = useSetAtom(poolsAtom)

  useEffect(() => {
    if (poolValues && !poolValues.error && poolValues.length > 0) {
      const pools = JSON.parse(poolValues)
      setPools(pools)
    }
  }, [poolValues, setPools])

  useSetupOnChain()

  useEffect(() => {
    sendEventLog("view_liquidations")
  }, [])

  useMarketSelection()

  return (
    <>
      <Seo
        data={{
          title: `${trans.seo.seo_title_liquidations}`,
          description: trans.seo.seo_description_liquidations,
        }}
      />
      <Layout>
        <Liquidations />
      </Layout>
    </>
  )
}
export const getStaticProps: GetStaticProps = async ({ locale }) => {
  const queryClient = new QueryClient()
  return {
    props: {
      locale,
      dehydratedState: dehydrate(queryClient),
    },
  }
}
export default LiquidationsPage
